<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false"
  >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center px-8 pt-6">
        <img class="w-56" src="images/logo/logo.svg" alt="Logo" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex min-h-screen w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card z-49 flex-0 relative flex h-16 w-full items-center justify-between px-4 shadow sm:h-20 md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden"
  >
    @if (!isScreenSmall) {
      <!-- Logo -->
      <div class="mx-2 flex items-center lg:mr-8">
        <img class="w-56" src="images/logo/logo.svg" alt="Logo" />
      </div>

      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation
        class="mr-2"
        [name]="'mainNavigation'"
        [navigation]="navigation.horizontal"
      ></fuse-horizontal-navigation>
    }
    <!-- Navigation toggle button -->
    @if (isScreenSmall) {
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
    }
    <!-- Components -->
    <div class="flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <!-- <languages></languages> -->
      <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
      <!-- <search [appearance]="'bar'"></search> -->
      <!-- <shortcuts></shortcuts> -->
      <!-- <messages></messages> -->
      <!-- <notifications></notifications> -->

      @if (false) {
        <!-- <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()"> -->
        <mat-icon
          [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
        ></mat-icon>
        <!-- </button> -->
      }

      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex w-full flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <!-- <div
    class="z-49 flex-0 relative flex h-14 w-full items-center border-t px-4 md:px-6 dark:bg-transparent print:hidden"
  >
    <a
      href="https://arsera.it/"
      target="_blank"
      rel="noopener noreferrer"
      class="text-secondary flex font-medium"
    >
      <span class="text-secondary font-medium"
        >ARSERA SRL. &copy; {{ currentYear }}</span
      >
      <img class="h-12" src="images/logo/arsera.svg" alt="Logo" />
    </a>
  </div> -->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
